import type { SVGProps } from 'react';
export const Unpin = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M10.95 3.35a1.2 1.2 0 0 1 1.7 0l4 4a1.2 1.2 0 0 1 0 1.7L13.7 12a.68.68 0 1 1-.96-.95l2.83-2.85-3.78-3.78-2.6 2.61a.68.68 0 1 1-.97-.95z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M7.86 12.14c.27.26.27.69 0 .95l-3.18 3.18a.68.68 0 0 1-.95-.95l3.18-3.18c.26-.27.69-.27.95 0"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M3.75 4.23c.28-.25.7-.23.96.05l10.53 11.59a.68.68 0 0 1-1 .9L3.7 5.2a.7.7 0 0 1 .05-.96"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M3.45 7.75a4.5 4.5 0 0 1 3.2-1.06.68.68 0 0 1-.1 1.35C6 8 5.24 8.1 4.42 8.7l6.86 6.86c.3-.41.6-1 .7-1.62a.68.68 0 1 1 1.34.19 5.4 5.4 0 0 1-1.06 2.4 1.2 1.2 0 0 1-1.8.12h-.01l-7.1-7.1a1.2 1.2 0 0 1 .1-1.8"
      clipRule="evenodd"
    />
  </svg>
);
